module.exports = __webpack_public_path__ + "img/damen_und_herren_duefte1_HINTERGRUND.59777680.jpg";